import { RootStore } from '@/store/Root.store'
import { makeAutoObservable } from 'mobx'

export class PdfViewerStore {
  rootStore: RootStore

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  // Page Navigation State
  totalPages = 0
  setTotalPages = (total: number): void => {
    this.totalPages = total
  }
  currentPageIndex = 0
  setCurrentPageIndex = (index: number): void => {
    this.currentPageIndex = index
  }

  // Scroll detection
  maxScrollOffset = 99999999
  setMaxScrollOffset = (offset: number): void => {
    this.maxScrollOffset = offset
  }

  // Zoom State
  pageScale = 1
  setPageScale = (scale: number): void => {
    this.pageScale = scale
  }
  zoomIn = (): void => {
    this.pageScale += 0.2
  }
  zoomOut = (): void => {
    this.pageScale -= 0.2
  }

  // Page Indicator State
  shouldShowPageIndicator = false
  setShouldShowPageIndicator = (value: boolean): void => {
    this.shouldShowPageIndicator = value
  }
  showPageIndicator = (): void => {
    this.shouldShowPageIndicator = true
  }

  // Reset on component mount
  resetViewerState = (): void => {
    this.totalPages = 0
    this.currentPageIndex = 0
    this.maxScrollOffset = 99999999
    this.pageScale = 1
    this.shouldShowPageIndicator = false
  }
}
